import React, { useState, useEffect } from 'react';
import { Row, Col, Button, Form, FormGroup, Input, Label } from 'reactstrap';
import PropTypes from 'prop-types';
import Body from '../Components/layout/Body';
import LearnMoreModal from '../Components/layout/LearnMoreModal';
import { 
  TEST_DRIVE_ACTIVITIES, 
  TD_TRY_START_HELP,
  DEFAULT_TEXT_LANGUAGE,
  TEXT_LANGUAGES,
  DEFAULT_TEXT_UNIT,
  OwnActivityInstructions, 
  TextEntryBasicInstructions, 
  PointingBasicInstructions, 
  SwitchBasicInstructions,
  DefaultActivityInstructions, 
  isBuiltInActivity,
  TEXT_UNITS,
  TARGET_TYPES,
  DEFAULT_TEXTS_IN_TEST,
  DEFAULT_TARGETS_IN_TEST,
  DEFAULT_TARGET_SIZE,
  DEFAULT_TARGET_TYPE,
  DEFAULT_HITS_IN_TEST} from './ConstForTestDriveSection';
import './Views.scss';
import TestDriveDevSidebar from './TestDriveDevSidebar';

const propTypes = {
  firstName: PropTypes.string,
  pronouns: PropTypes.arrayOf(PropTypes.string),
  activeTestDriveCurrentActivity: PropTypes.string,
  activeTestDriveCurrentActivityName: PropTypes.string,
  activeTestDriveCurrentActivityNumTexts: PropTypes.string,
  activeTestDriveCurrentActivityLanguage: PropTypes.string,
  activeTestDriveCurrentActivityTextUnit: PropTypes.string,
  activeTestDriveCurrentActivityNumTargets: PropTypes.string,
  activeTestDriveCurrentActivityTargetSize: PropTypes.string,
  activeTestDriveCurrentActivityTargetType: PropTypes.string,
  activeTestDriveCurrentActivityNumPrompts: PropTypes.string,
  activeTestDriveCurrentActivityPromptType: PropTypes.string,
  showSettings: PropTypes.bool,
  //these fxns aren't required because not all activities (e.g., your own activity) will have these settings
  onChangeActiveTestDriveCurrentActivityNumTexts: PropTypes.func,
  onChangeActiveTestDriveCurrentActivityLanguage: PropTypes.func,
  onChangeActiveTestDriveCurrentActivityTextUnit: PropTypes.func,
  onChangeActiveTestDriveCurrentActivityNumTargets: PropTypes.func,
  onChangeActiveTestDriveCurrentActivityTargetSize: PropTypes.func,
  onChangeActiveTestDriveCurrentActivityTargetType: PropTypes.func,
  onChangeActiveTestDriveCurrentActivityNumPrompts: PropTypes.func,
  onChangeActiveTestDriveCurrentActivityPromptType: PropTypes.func,
  setShowSettings: PropTypes.func.isRequired,
  saveFormData: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired
};

const defaultProps = {
  firstName: 'the client',
  pronouns: ['they', 'them', 'their'],
  activeTestDriveCurrentActivity: '',
  activeTestDriveCurrentActivityName: '',
};


//content sub-component with unique content for this page
function TestDriveTryStartContent(props) {
  const firstName = props.firstName;
  const pronouns = props.pronouns;
  const activeTestDriveCurrentActivity = props.activeTestDriveCurrentActivity;
  const activeTestDriveCurrentActivityName = props.activeTestDriveCurrentActivityName;
  const activeTestDriveCurrentActivityNumTexts = props.activeTestDriveCurrentActivityNumTexts;
  const onChangeActiveTestDriveCurrentActivityNumTexts = props.onChangeActiveTestDriveCurrentActivityNumTexts;
  const activeTestDriveCurrentActivityLanguage = props.activeTestDriveCurrentActivityLanguage;
  const onChangeActiveTestDriveCurrentActivityLanguage = props.onChangeActiveTestDriveCurrentActivityLanguage;
  const activeTestDriveCurrentActivityTextUnit = props.activeTestDriveCurrentActivityTextUnit;
  const onChangeActiveTestDriveCurrentActivityTextUnit = props.onChangeActiveTestDriveCurrentActivityTextUnit;
  const activeTestDriveCurrentActivityNumTargets = props.activeTestDriveCurrentActivityNumTargets;
  const onChangeActiveTestDriveCurrentActivityNumTargets = props.onChangeActiveTestDriveCurrentActivityNumTargets;
  const activeTestDriveCurrentActivityTargetSize = props.activeTestDriveCurrentActivityTargetSize;
  const onChangeActiveTestDriveCurrentActivityTargetSize = props.onChangeActiveTestDriveCurrentActivityTargetSize;
  const activeTestDriveCurrentActivityTargetType = props.activeTestDriveCurrentActivityTargetType;
  const onChangeActiveTestDriveCurrentActivityTargetType = props.onChangeActiveTestDriveCurrentActivityTargetType;
  const activeTestDriveCurrentActivityNumPrompts = props.activeTestDriveCurrentActivityNumPrompts;
  const onChangeActiveTestDriveCurrentActivityNumPrompts = props.onChangeActiveTestDriveCurrentActivityNumPrompts;
  const activeTestDriveCurrentActivityPromptType = props.activeTestDriveCurrentActivityPromptType;
  const onChangeActiveTestDriveCurrentActivityPromptType = props.onChangeActiveTestDriveCurrentActivityPromptType;
  const runOnSameComputer = props.runOnSameComputer;
  const onChangeRunOnSameComputer = props.onChangeRunOnSameComputer;
  const isLoggedIn = props.isLoggedIn;
  const showSettings = props.showSettings;
  const setShowSettings = props.setShowSettings;
  const onContinue = props.onContinue;

  //const [showSettings, setShowSettings] = useState(false);

  return(
    <>
    {(activeTestDriveCurrentActivityName) && (activeTestDriveCurrentActivity === TEST_DRIVE_ACTIVITIES.OWN_ACTIVITY)
      &&
      <p className='aa-proper-noun'>Activity: {activeTestDriveCurrentActivityName}</p>
    }
    
    <TestDriveTryStartInstructions 
      activityType={activeTestDriveCurrentActivity} 
      firstName={firstName}
      pronouns={pronouns}
    />

    { (isBuiltInActivity(activeTestDriveCurrentActivity) && !showSettings) && (
      <Row className="aa-review-row border-top">
        <Col>
          <Button color="secondary" onClick={() => setShowSettings(true)}><span className={`fa fa-gear fa-1x`}></span> Change activity settings</Button>
        </Col>
      </Row>
    )}
    { (isBuiltInActivity(activeTestDriveCurrentActivity) && showSettings) && (
      <Row className="aa-review-row border-top">
        <Col>
          <Row>
            <Col>
              <h5>Settings for this activity               
                <Button color="link" style={{paddingLeft:'12px'}} onClick={() => setShowSettings(false)}>hide</Button>
             </h5>
            </Col>
          </Row>
          <TestDriveTryStartSettings
            activityType={activeTestDriveCurrentActivity} 
            activeTestDriveCurrentActivityNumTexts={activeTestDriveCurrentActivityNumTexts}
            onChangeActiveTestDriveCurrentActivityNumTexts={onChangeActiveTestDriveCurrentActivityNumTexts}
            activeTestDriveCurrentActivityLanguage={activeTestDriveCurrentActivityLanguage}
            onChangeActiveTestDriveCurrentActivityLanguage={onChangeActiveTestDriveCurrentActivityLanguage}
            activeTestDriveCurrentActivityTextUnit={activeTestDriveCurrentActivityTextUnit}
            onChangeActiveTestDriveCurrentActivityTextUnit={onChangeActiveTestDriveCurrentActivityTextUnit}
            activeTestDriveCurrentActivityNumTargets={activeTestDriveCurrentActivityNumTargets}
            onChangeActiveTestDriveCurrentActivityNumTargets={onChangeActiveTestDriveCurrentActivityNumTargets}
            activeTestDriveCurrentActivityTargetSize={activeTestDriveCurrentActivityTargetSize}
            onChangeActiveTestDriveCurrentActivityTargetSize={onChangeActiveTestDriveCurrentActivityTargetSize}
            activeTestDriveCurrentActivityTargetType={activeTestDriveCurrentActivityTargetType}
            onChangeActiveTestDriveCurrentActivityTargetType={onChangeActiveTestDriveCurrentActivityTargetType}
            activeTestDriveCurrentActivityNumPrompts={activeTestDriveCurrentActivityNumPrompts}
            onChangeActiveTestDriveCurrentActivityNumPrompts={onChangeActiveTestDriveCurrentActivityNumPrompts}
            activeTestDriveCurrentActivityPromptType={activeTestDriveCurrentActivityPromptType}
            onChangeActiveTestDriveCurrentActivityPromptType={onChangeActiveTestDriveCurrentActivityPromptType}
            runOnSameComputer={runOnSameComputer}
            onChangeRunOnSameComputer={onChangeRunOnSameComputer}
            isLoggedIn={isLoggedIn}
          />
        </Col>
      </Row>
    )}

    <Row className="aa-review-row border-top">
      <Col>
        <p>When you and {firstName} are both ready, <strong>hit the Start button</strong> to begin.</p> 
        <Row> {/*className="justify-content-between"> */}
          <Col xs="auto">
            <Button color="primary" onClick={onContinue}>
              {isBuiltInActivity(activeTestDriveCurrentActivity) && <span className={`fa fa-clock-o fa-1x`}>&nbsp;</span>}
              Start the activity</Button>  
          </Col>
          {isBuiltInActivity(activeTestDriveCurrentActivity) && (
            <Col xs="auto">
              <Button color="secondary" onClick={(clickEvent) => onContinue(clickEvent, true)}>Practice</Button>
            </Col>
          )}
        </Row>
      </Col>
    </Row>

    {/* //TODO not sure we need this, but it's in the wireframes */}
    {/* {(activeTestDriveCurrentActivity===TEST_DRIVE_ACTIVITIES.OWN_ACTIVITY) ?
      <Row className="aa-review-row">
        <Col>
        <p className='aa-minor-note'><strong>Note: </strong>If you notice you're in the middle of the activity but forgot to hit the Start button (it happens!), just complete the activity, 
        then <Link to={update_path} >click here to Continue</Link>.
        </p>
        </Col>
        <Col lg={2}></Col>
      </Row>
    : <span></span>
    }  */}
    </>
  );

}
function TestDriveTryStartInstructions(props){
  const {
    activityType,
    firstName,
    pronouns
  } = props;
  return (
    <div>
       {(() => {
        switch (activityType) {
          case TEST_DRIVE_ACTIVITIES.OWN_ACTIVITY:
            return <OwnActivityInstructions firstName={firstName} pronouns={pronouns}/>;
          case TEST_DRIVE_ACTIVITIES.TEXT_ENTRY_BASIC:
            return <TextEntryBasicInstructions />;
          case TEST_DRIVE_ACTIVITIES.POINTING_BASIC:
            return <PointingBasicInstructions />;
          case TEST_DRIVE_ACTIVITIES.SWITCH_BASIC:
            return <SwitchBasicInstructions />;  
          default:
            return <DefaultActivityInstructions firstName={firstName} pronouns={pronouns}/>; 
        }
      })()}    
    </div>
  )
}

function TestDriveTryStartSettings(props){
  let {
    activityType,
    activeTestDriveCurrentActivityNumTexts = ('' + DEFAULT_TEXTS_IN_TEST),
    onChangeActiveTestDriveCurrentActivityNumTexts,
    activeTestDriveCurrentActivityLanguage,// = DEFAULT_TEXT_LANGUAGE,
    onChangeActiveTestDriveCurrentActivityLanguage,
    activeTestDriveCurrentActivityTextUnit,// = DEFAULT_TEXT_UNIT,
    onChangeActiveTestDriveCurrentActivityTextUnit,
    activeTestDriveCurrentActivityNumTargets = ('' + DEFAULT_TARGETS_IN_TEST),
    onChangeActiveTestDriveCurrentActivityNumTargets,
    activeTestDriveCurrentActivityTargetSize = ('' + DEFAULT_TARGET_SIZE),
    onChangeActiveTestDriveCurrentActivityTargetSize,
    activeTestDriveCurrentActivityTargetType = DEFAULT_TARGET_TYPE,
    onChangeActiveTestDriveCurrentActivityTargetType,
    activeTestDriveCurrentActivityNumPrompts = ('' + DEFAULT_HITS_IN_TEST),
    onChangeActiveTestDriveCurrentActivityNumPrompts,
    activeTestDriveCurrentActivityPromptType = DEFAULT_TARGET_TYPE,
    onChangeActiveTestDriveCurrentActivityPromptType,
    runOnSameComputer,
    onChangeRunOnSameComputer,
    isLoggedIn
  } = props;

  return (
    <div>
       {(() => {
        switch (activityType) {
          case TEST_DRIVE_ACTIVITIES.OWN_ACTIVITY:
            return <></>;
          case TEST_DRIVE_ACTIVITIES.TEXT_ENTRY_BASIC:
            return(
              <Form>
                <SettingsFormGroup
                  label='Number of trials:'
                  inputId='num-trials'
                  value={activeTestDriveCurrentActivityNumTexts}
                  onChange={onChangeActiveTestDriveCurrentActivityNumTexts}
                  type='number'
                />
                <SettingsFormGroup
                  label='Language:'
                  inputId='text-lang'
                  value={activeTestDriveCurrentActivityLanguage}
                  onChange={onChangeActiveTestDriveCurrentActivityLanguage}
                  type='select'
                  options={[TEXT_LANGUAGES.EN, TEXT_LANGUAGES.ES, TEXT_LANGUAGES.FR, TEXT_LANGUAGES.PTBR]}
                />
                <SettingsFormGroup
                  label='Text unit:'
                  inputId='text-unit'
                  value={activeTestDriveCurrentActivityTextUnit}
                  onChange={onChangeActiveTestDriveCurrentActivityTextUnit}
                  type='select'
                  options={[TEXT_UNITS.SENT, TEXT_UNITS.WORD, TEXT_UNITS.LTR]}
                />
                <hr/>
                <DeviceFormGroup
                  isLoggedIn={isLoggedIn}
                  runOnSameComputer={runOnSameComputer}
                  onChangeRunOnSameComputer={onChangeRunOnSameComputer}
                />          
              </Form>
            );
          case TEST_DRIVE_ACTIVITIES.POINTING_BASIC:
            return(
              <Form>
                <SettingsFormGroup
                  label='Number of targets:'
                  inputId='num-targets'
                  value={activeTestDriveCurrentActivityNumTargets}
                  onChange={onChangeActiveTestDriveCurrentActivityNumTargets}
                  type='number'
                />
                <SettingsFormGroup
                  label='Target size:'
                  inputId='target-size'
                  value={activeTestDriveCurrentActivityTargetSize}
                  onChange={onChangeActiveTestDriveCurrentActivityTargetSize}
                  type='number'
                />
                <SettingsFormGroup
                  label='Target type:'
                  inputId='target-type'
                  value={activeTestDriveCurrentActivityTargetType}
                  onChange={onChangeActiveTestDriveCurrentActivityTargetType}
                  type='select'
                  options={[TARGET_TYPES.CIRCLE, TARGET_TYPES.SMILEY]}
                />
                <hr/>
                <DeviceFormGroup
                  isLoggedIn={isLoggedIn}
                  runOnSameComputer={runOnSameComputer}
                  onChangeRunOnSameComputer={onChangeRunOnSameComputer}
                />          
              </Form>
            );
          case TEST_DRIVE_ACTIVITIES.SWITCH_BASIC:
            return(
              <Form>
                <SettingsFormGroup
                  label='Number of prompts:'
                  inputId='num-prompts'
                  value={activeTestDriveCurrentActivityNumPrompts}
                  onChange={onChangeActiveTestDriveCurrentActivityNumPrompts}
                  type='number'
                />
                <SettingsFormGroup
                  label='Prompt type:'
                  inputId='prompt-type'
                  value={activeTestDriveCurrentActivityPromptType}
                  onChange={onChangeActiveTestDriveCurrentActivityPromptType}
                  type='select'
                  options={[TARGET_TYPES.CIRCLE, TARGET_TYPES.SMILEY]}
                />
                <hr/>
                <DeviceFormGroup
                  isLoggedIn={isLoggedIn}
                  runOnSameComputer={runOnSameComputer}
                  onChangeRunOnSameComputer={onChangeRunOnSameComputer}
                />          
              </Form>
            );
          default:
            return <></>; 
        }
      })()}  
    </div>
  )
}

function SettingsFormGroup(props){
  const{
    inputId,
    label,
    value,
    onChange,
    type,
    options //only applies to select inputs
  } = props;

  return(              
    <FormGroup row>
      <Label for={inputId} lg={4}>
        {label}
      </Label>
      <Col lg={8} className="col-form-label">
        <Input
        id={inputId}
        value={value}
        onChange={onChange}
        name={inputId}
        type={type}
        >
        {options && options.map((val, i) => <option key={i} value={val}>{val}</option>)}
        </Input>
      </Col>
    </FormGroup>
  );  
}
function DeviceFormGroup(props){
  const{
    isLoggedIn,
    runOnSameComputer,
    onChangeRunOnSameComputer
  } = props;
  const runLegend = `Run this activity on:`;
  const runId = "run-on-device";
  const runBtns = [
    {
      value: 'true',
      label: `This device`,
      moreInfo: ''
    },
    {
      value: 'false',
      label: `Another device`,
      moreInfo: ''
    }
  ];

  return(
  <FormGroup  tag="fieldset" key={runId}>
    <legend className={!isLoggedIn ? "aa-legend-disabled" : ""}>{runLegend} 
      {' '}
      <DeviceInfoButton />
    </legend> 
    {runBtns.map((btn, index) =>
      <FormGroup className={""} check key={index}>
        <Input
          id={runId+index}
          value={btn.value}
          checked={runOnSameComputer===btn.value}
          onChange={onChangeRunOnSameComputer}
          name={runId}
          disabled={!isLoggedIn}
          type="radio"
        />
        {' '}
        <Label for={runId+index} check>
          {btn.label}
          {' '}
        </Label>
      </FormGroup>
    )}
  </FormGroup>
  );
}
function DeviceInfoButton(props){
  return(
  <LearnMoreModal linkText="" 
    buttonClassName="aa-no-padding aa-secondary-link"
    title="Where to run this activity" 
    content="
        <p>By default, we assume you'll run an activity on the same device you're using to run Access Navigator.
       So you and the client will use the same computing device.</p>
        <p>But sometimes you might want to run an activity on a different device. For example, you may be using your own laptop to run Access Navigator. 
        The client has their own iPad that is mounted in a specific way for their use. You'd really like to run any activities on that iPad, to get the most realistic results.</p>
        <p>To do that, the first step is to select 'Another device' here. (Make sure you are logged in.) Then once you click Start or Practice, you'll get specific instructions on how to start the activity on another device.</p>
        <p><strong>Note:</strong> This choice only applies to the in-app activities (text entry, point and click, and switch). For running Your Own Activity, you can always use whatever device you want.</p>"/>
  );
}
//main component for this page
//basic pattern is to set up the pageData, define the unique content for the page (above),
//then render the page using <Body> component
function TestDriveTryStart(props) {
  const firstName = props.firstName;
  const pronouns = props.pronouns;
  const activeTestDriveCurrentActivity = props.activeTestDriveCurrentActivity;
  const activeTestDriveCurrentActivityName = props.activeTestDriveCurrentActivityName;
  const activeTestDriveCurrentActivityNumTexts = props.activeTestDriveCurrentActivityNumTexts;
  const onChangeActiveTestDriveCurrentActivityNumTexts = props.onChangeActiveTestDriveCurrentActivityNumTexts;
  const activeTestDriveCurrentActivityLanguage = props.activeTestDriveCurrentActivityLanguage;
  const onChangeActiveTestDriveCurrentActivityLanguage = props.onChangeActiveTestDriveCurrentActivityLanguage;
  const activeTestDriveCurrentActivityTextUnit = props.activeTestDriveCurrentActivityTextUnit;
  const onChangeActiveTestDriveCurrentActivityTextUnit = props.onChangeActiveTestDriveCurrentActivityTextUnit;
  const activeTestDriveCurrentActivityNumTargets = props.activeTestDriveCurrentActivityNumTargets;
  const onChangeActiveTestDriveCurrentActivityNumTargets = props.onChangeActiveTestDriveCurrentActivityNumTargets;
  const activeTestDriveCurrentActivityTargetSize = props.activeTestDriveCurrentActivityTargetSize;
  const onChangeActiveTestDriveCurrentActivityTargetSize = props.onChangeActiveTestDriveCurrentActivityTargetSize;
  const activeTestDriveCurrentActivityTargetType = props.activeTestDriveCurrentActivityTargetType;
  const onChangeActiveTestDriveCurrentActivityTargetType = props.onChangeActiveTestDriveCurrentActivityTargetType;
  const activeTestDriveCurrentActivityNumPrompts = props.activeTestDriveCurrentActivityNumPrompts;
  const onChangeActiveTestDriveCurrentActivityNumPrompts = props.onChangeActiveTestDriveCurrentActivityNumPrompts;
  const activeTestDriveCurrentActivityPromptType = props.activeTestDriveCurrentActivityPromptType;
  const onChangeActiveTestDriveCurrentActivityPromptType = props.onChangeActiveTestDriveCurrentActivityPromptType;
  const runOnSameComputer = props.runOnSameComputer;
  const onChangeRunOnSameComputer = props.onChangeRunOnSameComputer;
  const isLoggedIn = props.isLoggedIn;
  const showSettings = props.showSettings;
  const setShowSettings = props.setShowSettings;
  const setRunningPractice = props.setRunningPractice;
  const saveFormData = props.saveFormData;
  const onContinue = props.onContinue;
  const dev = props.dev || {};

  const pageData = {
    image: "./assets/images/target-icon.jpg",
    faIcon: "fa-road aa-fa-3x",
    pageSymbolClassName: "aa-section-symbol test-drive",
    title: `Start your Test-drive Activity when ready!`,
    subTitle: ``,
    learnMore: {linkText: "Learn More about what to look for during an activity",
                title: "Observing an activity",
                content: TD_TRY_START_HELP
                },
    nextRoute: "", //not needed since we are using on
    sidebar: false
  }

  console.log("Rendering TestDriveTryStart, numTexts: " + activeTestDriveCurrentActivityNumTexts + "  numPrompts: " + activeTestDriveCurrentActivityNumPrompts + " prompt type: " + activeTestDriveCurrentActivityPromptType);
  
  useEffect(() => {
    console.log('TestDriveTryStart mounted');
    return () => {
      console.log('TestDriveTryStart unmounting and saving...');
      saveFormData();
    }
  }, [saveFormData])

  return(
    <>
    <Body page={pageData} 
      contentComponent={
        <TestDriveTryStartContent 
          firstName={firstName}
          pronouns={pronouns}
          activeTestDriveCurrentActivity={activeTestDriveCurrentActivity}
          activeTestDriveCurrentActivityName={activeTestDriveCurrentActivityName}
          activeTestDriveCurrentActivityNumTexts={activeTestDriveCurrentActivityNumTexts}
          onChangeActiveTestDriveCurrentActivityNumTexts={onChangeActiveTestDriveCurrentActivityNumTexts}
          activeTestDriveCurrentActivityLanguage={activeTestDriveCurrentActivityLanguage}
          onChangeActiveTestDriveCurrentActivityLanguage={onChangeActiveTestDriveCurrentActivityLanguage}
          activeTestDriveCurrentActivityTextUnit={activeTestDriveCurrentActivityTextUnit}
          onChangeActiveTestDriveCurrentActivityTextUnit={onChangeActiveTestDriveCurrentActivityTextUnit}
          activeTestDriveCurrentActivityNumTargets={activeTestDriveCurrentActivityNumTargets}
          onChangeActiveTestDriveCurrentActivityNumTargets={onChangeActiveTestDriveCurrentActivityNumTargets}
          activeTestDriveCurrentActivityTargetSize={activeTestDriveCurrentActivityTargetSize}
          onChangeActiveTestDriveCurrentActivityTargetSize={onChangeActiveTestDriveCurrentActivityTargetSize}
          activeTestDriveCurrentActivityTargetType={activeTestDriveCurrentActivityTargetType}
          onChangeActiveTestDriveCurrentActivityTargetType={onChangeActiveTestDriveCurrentActivityTargetType}
          activeTestDriveCurrentActivityNumPrompts={activeTestDriveCurrentActivityNumPrompts}
          onChangeActiveTestDriveCurrentActivityNumPrompts={onChangeActiveTestDriveCurrentActivityNumPrompts}
          activeTestDriveCurrentActivityPromptType={activeTestDriveCurrentActivityPromptType}
          onChangeActiveTestDriveCurrentActivityPromptType={onChangeActiveTestDriveCurrentActivityPromptType}
          runOnSameComputer={runOnSameComputer}
          onChangeRunOnSameComputer={onChangeRunOnSameComputer}
          isLoggedIn={isLoggedIn}
          showSettings={showSettings}
          setShowSettings={setShowSettings}
          setRunningPractice={setRunningPractice}
          onContinue={onContinue}
        />
      } 
      sidebarComponent={
        dev.showDevSidebar 
        &&
        <TestDriveDevSidebar 
          activeTestDriveId={dev.tdId}
          activeTestDrive={dev.td}
          activeTestDriveActivityId={dev.actId}
          activeTestDriveActivities={dev.acts}
          completedTestDrives={dev.ctds}
        />  
      }
      onContinue={onContinue}  
    />
    </>
  );
}

TestDriveTryStart.propTypes = propTypes;
TestDriveTryStart.defaultProps = defaultProps;

export default TestDriveTryStart;